import React from 'react';
import { Box } from '@mui/material';
import ImageCrop from '../../common/ImageCrop';

const ImageTab = ({ project, getFullImageUrl, imageCropSaveFunc }) => {
  return (
    <Box>
      <ImageCrop
        imageUrl={project?.projectImage?.url?.toLowerCase().includes('.svg') ? null : getFullImageUrl()}
        saveImageFunction={imageCropSaveFunc}
        deleteImageFunction={null}
        imageSaveName="project-image"
        editorWidth={800}
        editorHeight={400}
        acceptedFormats=".jpg,.jpeg,.png,.gif"
      />
    </Box>
  );
};

export default ImageTab;
